import { updater } from "../../utils/updater.js";

/**
 * Profile API factory.
 *
 */
export function profileFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const getSubUsers = () => state.subUsers;
  const getSelectedSubUser = () => state.selectedSubUser;
  const getLoading = () => state.loading;

  const setSubUsers = (subUsers) => {
    updateState((draft) => {
      draft.subUsers = subUsers;
    });
  };

  const changeSubUserStatusFromExpiredToPending = (subUserEmail) => {
    const subUserIndex = state.subUsers.findIndex(
      ({ Email }) => Email === subUserEmail
    );
    if (subUserIndex !== -1) {
      updateState((draft) => {
        draft.subUsers[subUserIndex].Status = "pending";
      });
    }
  };
  const setNumberOfUsers = (numberOfUsers) => {
    updateState((draft) => {
      draft.numberOfUsers = numberOfUsers;
    });
  };

  const setLoading = (loading) => {
    updateState((draft) => {
      draft.loading = loading;
    });
  };

  const setSelectedSubUser = (selectedSubUser) => {
    updateState((draft) => {
      draft.selectedSubUser = selectedSubUser;
    });

    // scroll to top
    window.scrollTo(0, 0);
  };

  const getSubUserData = () => {
    return {
      numberOfUsers: state.numberOfUsers,
      orderAscending: state.orderAscending,
      fieldToOrder: state.fieldToOrder,
      currentPage: state.currentPage,
      sizeNumber: state.sizeNumber,
      permissionFilter: state.permissionFilter,
      statusFilter: state.statusFilter,
      searchTerm: state.searchTerm,
    };
  };

  const setSubUsersCounts = (payload) => {
    updateState((draft) => {
      draft.subUsersCounts = payload;
    });
  };

  const getSubUsersCounts = () => state.subUsersCounts;

  const setSearchTerm = (value) => {
    updateState((draft) => {
      draft.searchTerm = value;
    });
  };

  const getSearchTerm = () => state.searchTerm;

  const setPermissionFilter = (value) => {
    updateState((draft) => {
      draft.permissionFilter = value;
    });
  };

  const getPermissionFilter = () => state.permissionFilter;

  const setStatusFilter = (value) => {
    updateState((draft) => {
      draft.statusFilter = value;
    });
  };

  const getStatusFilter = () => state.statusFilter;

  const setOrderAscending = (orderAscending) => {
    updateState((draft) => {
      draft.orderAscending = orderAscending;
    });
  };

  const setSizeNumber = (sizeNumber) => {
    updateState((draft) => {
      draft.sizeNumber = sizeNumber;
    });
  };

  const setFieldToOrder = (fieldToOrder) => {
    updateState((draft) => {
      draft.fieldToOrder = fieldToOrder;
    });
  };

  const setCurrentPage = (currentPage) => {
    updateState((draft) => {
      draft.currentPage = currentPage === 1 ? 0 : currentPage - 1;
    });
  };

  return {
    setFieldToOrder,
    setOrderAscending,
    setSelectedSubUser,
    getSelectedSubUser,
    getSubUsers,
    getLoading,
    setSubUsers,
    setNumberOfUsers,
    setLoading,
    getSubUserData,
    setCurrentPage,
    setSizeNumber,
    setSearchTerm,
    setStatusFilter,
    setPermissionFilter,
    getSearchTerm,
    getStatusFilter,
    getPermissionFilter,
    setSubUsersCounts,
    getSubUsersCounts,
    changeSubUserStatusFromExpiredToPending,
  };
}

export default profileFactory;
